import { all, call } from 'redux-saga/effects';
import cluster from './cluster/clusterSagas';
import volume from './volume/volumeSagas';

export default function* blockSaga() {
	yield all([call(cluster), call(volume)]);
}
